// extracted by mini-css-extract-plugin
export var breadcrumbs = "SiteLayout-module--breadcrumbs--p2h2J";
export var component = "SiteLayout-module--component--8SjYu";
export var content = "SiteLayout-module--content--YvtMA";